import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {CurrentTimeService} from '@services/helpers/current-time/current-time.service';
import {AppointmentListItem} from '@models/data/appointments/AppointmentListItem';
import {Subject} from 'rxjs/internal/Subject';
import {takeUntil} from 'rxjs/operators';
import { ConsultationPopupRibbonService } from '@src/app/shared/services/core/consultation-popup/consultation-popup-ribbon.service';
import { ConsultationPopupItemComponent } from './consultation-popup-item/consultation-popup-item.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-consultation-popup',
    templateUrl: './consultation-popup.component.html',
    styleUrls: ['./consultation-popup.component.scss'],
    viewProviders: [CurrentTimeService],
    standalone: true,
    imports: [ConsultationPopupItemComponent, AsyncPipe]
})
export class ConsultationPopupComponent implements OnInit, OnDestroy {

  private unsub = new Subject<void>();

  // Array for next 3 appointments
  appointmentList: AppointmentListItem[];

  constructor(
    public consultationPopup: ConsultationPopupRibbonService,
    private cd : ChangeDetectorRef
  ) {
    this.consultationPopup.displayNextAppointments$.pipe(takeUntil(this.unsub)).subscribe(c => {
      this.appointmentList = c;
    })
  }

  ngOnInit(): void {
    this.consultationPopup.ngOnInit()
  }

  ngOnDestroy(): void {
    this.unsub.next();
    this.unsub.complete();

    this.consultationPopup.ngOnDestroy()
  }

  /**
   * function to track any change with the appointments item
   * @param index
   * @param item
   * @returns string based on appointmentId and recordedStartTime
   */
  appointmentTrackBy(index: number, item: AppointmentListItem): string {
    return `${item.appointment.id}${item.appointment.recordedStartTime}`;
  }
}
